<template>
  <div class="search_result_box">
    <div class="container">
      <good-list :good-list="goodList" />
      <el-empty v-if="!goodListLoading && !goodList.length" description=" "></el-empty>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      goodListLoading: false,
      goodList: [],
      timer: null,
    }
  },
  computed: {
    headSearchKeywords() {
      return this.$store.state.headSearchKeywords
    }
  },
  watch: {
    headSearchKeywords() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.getgoodList();
      }, 300)
    }
  },
  mounted() {
    this.getgoodList();
    this.eventBus.$on("searchConfirm", () => this.getgoodList())
  },
  beforeDestroy() {
    clearTimeout(this.timer)
    this.eventBus.$off("searchConfirm")
  },
  methods: {
    /** 获取列表 */
    async getgoodList() {
      try {
        this.goodListLoading = true;
        var res = await this.$get('system/goods/list', {
          name: this.$store.state.headSearchKeywords,
          pageNum: this.goodListpage,
          pageSize: this.goodList_rows,
          brandId: "",
          type: 1,
        })
        this.goodList = this.goodListAttrFormat(res.rows || []);
      } catch (error) {
      }
      this.goodListLoading = false;
    },
  }
}
</script>

<style scoped lang="scss">
.search_result_box {
  padding: 30px 0;
}
</style>
